// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table_row-clickable{cursor:pointer}.table_row-disabled{opacity:0.5;pointer-events:none}.table_row_darkened{background-color:#f9f9f9}\n", ""]);
// Exports
module.exports = exports;
